// extracted by mini-css-extract-plugin
module.exports = {"heading":"Shop_heading__37r4d","headingTwo":"Shop_headingTwo__1uVRi"};